module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/index/index.component.scss
// module id = ./src/app/routes/index/index.component.scss
// module chunks = 9